import React from "react";
import headgasket from "../resources/headgasket.png";
import axle from "../resources/axle.png";
import brakes from "../resources/brakes.png";
import alternator from "../resources/alternator.png";
import ac from "../resources/ac.png";
import tires from "../resources/tires.png";
import oilchange from "../resources/oilchange.png";
import cardiagnostic from "../resources/cardiagnostic.png";
import clutch from "../resources/clutch.png";
import turbo from "../resources/turbo.png";
import transmission from "../resources/transmission.png";
import carengine from "../resources/carengine.png";
import logo from "../resources/blacklogo.png";

function ServicesPage() {
  const services = [
    { title: "Head Gasket", img: headgasket },
    { title: "Axle", img: axle },
    { title: "Brakes", img: brakes },
    { title: "Alternator", img: alternator },
    { title: "AC", img: ac },
    { title: "Tires", img: tires },
    { title: "Oil Change", img: oilchange },
    { title: "Car Diagnostic", img: cardiagnostic },
    { title: "Clutch", img: clutch },
    { title: "Turbo", img: turbo },
    { title: "Transmission", img: transmission },
    { title: "Car Engine", img: carengine },
  ];

  return (
    <main className="bg-white">
      {/* Page header */}
      <section className="relative bg-zinc-950 text-white overflow-hidden">
        <div className="absolute inset-0 bg-grid-pattern bg-[size:50px_50px] opacity-[0.08]"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-500/15 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-20 md:pb-28">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-xs uppercase tracking-[0.2em] font-semibold mb-6 reveal">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-500 animate-pulse"></span>
            Our Services
          </div>
          <h1 className="reveal reveal-delay-1 font-chivo text-4xl md:text-6xl lg:text-7xl font-black leading-[0.95] tracking-tight max-w-4xl">
            Services you can{" "}
            <span className="gradient-text">trust us</span> with.
          </h1>
        </div>
      </section>

      {/* Main content */}
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-start">
          {/* Services grid */}
          <div>
            <div className="grid grid-cols-2 gap-3">
              {services.map((service) => (
                <div
                  key={service.title}
                  className="group flex items-center gap-3 px-4 py-5 rounded-2xl bg-white border border-zinc-200/80 shadow-sm hover:shadow-md hover:border-brand-500/40 hover:-translate-y-0.5 transition-all"
                >
                  <div className="w-11 h-11 flex-shrink-0 rounded-xl bg-zinc-100 group-hover:bg-gradient-to-br group-hover:from-brand-500 group-hover:to-brand-800 flex items-center justify-center transition-all">
                    <img
                      src={service.img}
                      alt={service.title}
                      className="w-7 h-7 grayscale group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert transition-all"
                    />
                  </div>
                  <h3 className="uppercase font-chivo text-xs md:text-sm font-semibold text-zinc-800">
                    {service.title}
                  </h3>
                </div>
              ))}
            </div>
            <p className="mt-6 text-center text-zinc-500 font-dancing text-2xl md:text-3xl">
              and many more...
            </p>
          </div>

          {/* Text content */}
          <div className="md:sticky md:top-32 font-montserrat text-zinc-700">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/10 text-brand-700 text-xs font-semibold uppercase tracking-[0.2em] mb-5">
              About Bini Autorepair
            </div>
            <h2 className="font-chivo font-black text-3xl md:text-5xl text-zinc-900 leading-tight tracking-tight mb-8">
              Your Trusted Auto Repair Destination in{" "}
              <span className="gradient-text">NYC</span>
            </h2>

            <div className="space-y-5 text-base md:text-lg leading-relaxed text-zinc-600">
              <p>
                Welcome to Bini Autorepair INC, your premier destination for
                automotive services in New York City.
              </p>
              <p>
                Located at 10 Eastman Pl, Yonkers, NY 10701, we bring over 25
                years of expertise and dedication to every vehicle we service.
                At Bini Autorepair INC, we pride ourselves on delivering
                top-quality automotive solutions tailored to your needs.
              </p>
              <p>
                From routine maintenance to complex repairs, our team of
                experienced technicians is committed to providing exceptional
                service and ensuring your vehicle operates at its best. From
                oil changes to engine and transmission swaps, we offer a
                comprehensive range of services designed to meet all your
                automotive needs. With our attention to detail and commitment
                to excellence, you can trust us to keep your vehicle running
                smoothly and reliably on the road.
              </p>
              <p className="text-brand-700 font-bold font-chivo text-xl md:text-2xl leading-snug pt-2">
                Book your appointment with Bini Autorepair INC today and
                experience the difference of our unparalleled service and
                expertise.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call banner */}
      <section className="relative py-20 md:py-28 bg-zinc-950 text-white overflow-hidden">
        <div className="absolute inset-0 bg-grid-pattern bg-[size:40px_40px] opacity-[0.07]"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-brand-500/20 rounded-full blur-3xl"></div>

        <a
          href="tel:+13475820864"
          className="relative block max-w-4xl mx-auto text-center px-6 group"
        >
          <p className="uppercase tracking-[0.3em] text-brand-400 text-sm md:text-base font-bold mb-4">
            Call us now !!
          </p>
          <p className="font-chivo font-black text-5xl md:text-7xl lg:text-8xl gradient-text group-hover:scale-105 transition-transform inline-block">
            +13475820864
          </p>
          <p className="mt-6 text-zinc-400 font-dancing text-2xl md:text-3xl">
            or visit us
          </p>
        </a>
      </section>

      {/* Map */}
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <div className="rounded-3xl overflow-hidden border border-zinc-200 shadow-soft">
          <iframe
            width="100%"
            height="560"
            frameBorder="0"
            title="map"
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=BiniAutoRepairINC,%2010%20Eastman%20Pl,%20Yonkers,%20NY%2010701,%20United%20States+(Bini%20Autorepair%20INC)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
          >
            <a href="https://www.gps.ie/">gps tracker sport</a>
          </iframe>
        </div>
        <img
          src={logo}
          alt=""
          className="w-32 h-16 object-contain opacity-60 mx-auto mt-10"
        />
      </section>
    </main>
  );
}

export default ServicesPage;
